
// This file organizes all image URLs used in the application
// Using placeholder images for now, to be replaced with actual PK Landscape images

export const images = {
  // Hero images - updated to more reliable sources
  hero: {
    main: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=2070&auto=format&fit=crop",
    secondary: "https://images.unsplash.com/photo-1626178793926-22b28830aa30?q=80&w=2070&auto=format&fit=crop",
    tertiary: "https://images.unsplash.com/photo-1444492417251-9c84a5fa18e0?q=80&w=2070&auto=format&fit=crop",
  },
  
  // About section
  about: {
    owner: "https://images.unsplash.com/photo-1622030411594-c580cbae9b66?q=80&w=1854&auto=format&fit=crop",
    team: "https://images.unsplash.com/photo-1605000797499-95a51c5269ae?q=80&w=2071&auto=format&fit=crop",
  },
  
  // Services
  services: [
    {
      id: 1,
      title: "Landscape Design",
      description: "Custom landscape architecture and design services tailored to your property's unique characteristics and your personal style.",
      image: "/lovable-uploads/81635626-ab5c-4ce5-af4d-085dda847330.png",
      features: [
        "Custom design concepts",
        "3D visualization",
        "Plant selection expertise",
        "Sustainable design practices",
        "Drainage solutions",
      ]
    },
    {
      id: 2,
      title: "Installation",
      description: "Expert installation of all landscape elements, from plantings and hardscapes to lighting and irrigation systems.",
      image: "/lovable-uploads/c9bab5be-8111-40c6-ae6f-a50a0408b536.png",
      features: [
        "Patios & walkways",
        "Retaining walls",
        "Water features",
        "Outdoor lighting",
        "Planting & mulching",
      ]
    },
    {
      id: 3,
      title: "Maintenance",
      description: "Comprehensive maintenance programs to keep your landscape looking its best throughout the seasons.",
      image: "/lovable-uploads/b541e3ea-3486-4882-934b-2e604eba9aae.png",
      features: [
        "Weekly lawn service",
        "Seasonal cleanups",
        "Pruning & trimming",
        "Fertilization programs",
        "Pest management",
      ]
    },
    {
      id: 4,
      title: "Snow Removal",
      description: "Reliable snow removal services for residential and commercial properties throughout Fairfield County.",
      image: "/lovable-uploads/9216b89d-ba69-4cc8-b256-62958ce234c8.png",
      features: [
        "24/7 monitoring",
        "Plowing & shoveling",
        "Ice management",
        "Sidewalk clearing",
        "Salt/sand application",
      ]
    },
  ],
  
  // Portfolio - updated image URLs to more reliable sources
  portfolio: [
    {
      id: 1,
      title: "Modern Backyard Transformation",
      category: "Residential",
      location: "Greenwich, CT",
      image: "/lovable-uploads/c9bab5be-8111-40c6-ae6f-a50a0408b536.png",
      beforeImage: "https://images.unsplash.com/photo-1594495894542-a46cc73e081a?q=80&w=2071&auto=format&fit=crop",
      description: "A complete transformation of an outdated backyard into a modern outdoor living space with custom patio, fire pit, and native plantings."
    },
    {
      id: 2,
      title: "Commercial Plaza Landscaping",
      category: "Commercial",
      location: "Stamford, CT",
      image: "/lovable-uploads/9216b89d-ba69-4cc8-b256-62958ce234c8.png",
      beforeImage: "https://images.unsplash.com/photo-1471970394675-613138e45da3?q=80&w=2040&auto=format&fit=crop",
      description: "Redesign of a commercial plaza entry with drought-resistant plants, improved drainage, and a welcoming seating area."
    },
    {
      id: 3,
      title: "Garden Patio & Walkway",
      category: "Residential",
      location: "Westport, CT",
      image: "/lovable-uploads/81635626-ab5c-4ce5-af4d-085dda847330.png",
      beforeImage: "https://images.unsplash.com/photo-1516253593875-bd7ba052fbc5?q=80&w=2070&auto=format&fit=crop",
      description: "Installation of a natural stone patio and winding garden path, surrounded by perennial gardens and accent lighting."
    },
    {
      id: 4,
      title: "Poolside Landscape Design",
      category: "Residential",
      location: "Darien, CT",
      image: "https://images.unsplash.com/photo-1551927411-95e412943b58?q=80&w=2069&auto=format&fit=crop",
      beforeImage: "https://images.unsplash.com/photo-1531628683076-8a639adad39f?q=80&w=2071&auto=format&fit=crop",
      description: "Poolside retreat featuring tropical plantings, custom stonework, and privacy screening for year-round enjoyment."
    },
    {
      id: 5,
      title: "Corporate Campus Renovation",
      category: "Commercial",
      location: "Norwalk, CT",
      image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=2069&auto=format&fit=crop",
      beforeImage: "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?q=80&w=2070&auto=format&fit=crop",
      description: "Comprehensive renovation of a corporate campus entrance and courtyard, featuring sustainable landscaping practices."
    },
    {
      id: 6,
      title: "Waterfront Property Landscaping",
      category: "Residential",
      location: "Fairfield, CT",
      image: "/lovable-uploads/b541e3ea-3486-4882-934b-2e604eba9aae.png",
      beforeImage: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?q=80&w=2071&auto=format&fit=crop",
      description: "Coastal landscaping design for a waterfront property, including erosion control, salt-tolerant plantings, and natural stone steps."
    },
  ],
  
  // Testimonials
  testimonials: {
    client1: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1961&auto=format&fit=crop",
    client2: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1974&auto=format&fit=crop",
    client3: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1974&auto=format&fit=crop",
  },
  
  // Logos
  logo: {
    primary: "https://placehold.co/200x80/ffffff/333333?text=PK+Landscape",
    footer: "https://placehold.co/200x80/ffffff/333333?text=PK+Landscape",
    badge: "https://placehold.co/50x50/ffffff/333333?text=PK",
  },
  
  // Icons and UI elements can be added here
  icons: {
    arrow: "https://placehold.co/24x24/ffffff/333333?text=→",
  }
};

// Testimonial data
export const testimonials = [
  {
    id: 1,
    name: "Jennifer Davis",
    location: "Greenwich, CT",
    image: images.testimonials.client1,
    text: "PK Landscape Associates transformed our backyard into an outdoor oasis. Paul's attention to detail and expertise in plant selection created a space that looks beautiful year-round. The entire team was professional and a pleasure to work with.",
    rating: 5,
  },
  {
    id: 2,
    name: "Robert Thomson",
    location: "Stamford, CT",
    image: images.testimonials.client2,
    text: "We hired PK Landscape for our commercial property maintenance and couldn't be happier. They're reliable, thorough, and have significantly improved the appearance of our business exterior. Their snow removal service was also excellent this past winter.",
    rating: 5,
  },
  {
    id: 3,
    name: "Michael Chen",
    location: "Westport, CT",
    image: images.testimonials.client3,
    text: "Working with Paul and his team was a wonderful experience from start to finish. They listened to our ideas and created a landscape design that exceeded our expectations. We especially love the stone patio and native garden installation.",
    rating: 5,
  },
];
